/* eslint-disable */
import type { DateOnlyString } from '@libs/trip-planner-interfaces';
import type { URLString } from '@libs/trip-planner-interfaces';
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** The `Date` scalar type represents a year, month and day in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  Date: { input: unknown; output: unknown };
  /** The `Date` scalar type represents a year, month and day in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. Format is `yyyy-MM-dd` */
  DateOnly: { input: DateOnlyString; output: DateOnlyString };
  /** The `DateTime` scalar type represents a date and time. `DateTime` expects timestamps to be formatted in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  DateTime: { input: string; output: string };
  Decimal: { input: number; output: number };
  Uri: { input: URLString; output: URLString };
};

export type AIThreadResponseQL = {
  additionalRecipes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  additionalTexts?: Maybe<AdditionalTextQL>;
  messageId?: Maybe<Scalars['String']['output']>;
  multiTrip?: Maybe<Scalars['Boolean']['output']>;
  recipeJson?: Maybe<Scalars['String']['output']>;
  replyToUser?: Maybe<Scalars['String']['output']>;
  selectedDay?: Maybe<Scalars['DateOnly']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
};

export type ActivityQL = {
  code?: InputMaybe<Scalars['String']['input']>;
  dateOnly?: InputMaybe<Scalars['DateOnly']['input']>;
  tickets?: InputMaybe<Array<InputMaybe<SelectedTicketQL>>>;
};

export type ActivityResultQL = {
  activityTicketResults?: Maybe<Array<Maybe<ActivityTicketResultQL>>>;
  code: Scalars['String']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  prices?: Maybe<PriceQL>;
};

export type ActivityTicketResultQL = {
  ageRangeId?: Maybe<Scalars['String']['output']>;
  alternative: Scalars['Boolean']['output'];
  dateMainEvent?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  estimatedDate?: Maybe<Scalars['DateOnly']['output']>;
  isConfirmed: Scalars['Boolean']['output'];
  maxAge?: Maybe<Scalars['Int']['output']>;
  minAge: Scalars['Int']['output'];
  minimumTicketsPerAgeRange?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<MoneyQL>;
  quantityAvailable?: Maybe<Scalars['Int']['output']>;
  quantityOfTickets: Scalars['Int']['output'];
  rateId?: Maybe<Scalars['String']['output']>;
  supplierToken?: Maybe<Scalars['String']['output']>;
  ticketEndDate?: Maybe<Scalars['DateOnly']['output']>;
  ticketStartDate?: Maybe<Scalars['DateOnly']['output']>;
  timeSlotId?: Maybe<Scalars['String']['output']>;
  timeSlotStartTime?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AdditionalTextQL = {
  destinations?: Maybe<Array<Maybe<DestinationAdditionalTextQL>>>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  inspirationalMessage?: Maybe<Scalars['String']['output']>;
};

export type AgeRangeQL = {
  availableTimeslotsPrices?: Maybe<
    Array<Maybe<AvailableTimeslotsPricesProjectedQL>>
  >;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  maxAge?: Maybe<Scalars['Int']['output']>;
  minAge: Scalars['Int']['output'];
  minimumTicketsPerAgeRange?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<MoneyQL>;
  prices?: Maybe<PriceQL>;
  quantityAvailable?: Maybe<Scalars['Int']['output']>;
  supplierToken?: Maybe<Scalars['String']['output']>;
};

export type AvailableTimeslotsPricesProjectedQL = {
  amount: Scalars['Decimal']['output'];
  availabletimeSlotId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  quantityAvailable?: Maybe<Scalars['Int']['output']>;
};

export type BoardBasisOptionsResponseQL = {
  boardBasis?: Maybe<Scalars['String']['output']>;
  isRefundable: Scalars['Boolean']['output'];
  prices?: Maybe<MoneyQL>;
  roomStays?: Maybe<Array<Maybe<RoomStayResponseQL>>>;
};

export type BookingTokenRequestQL = {
  activities?: InputMaybe<Array<InputMaybe<ActivityQL>>>;
  affiliateId?: InputMaybe<Scalars['String']['input']>;
  market: Scalars['Uri']['input'];
};

export type CancellationPolicyResponseQL = {
  amount?: Maybe<MoneyQL>;
  fromDate?: Maybe<Scalars['String']['output']>;
  fromDateIso?: Maybe<Scalars['String']['output']>;
};

export type CheapestHotelStayRequestQL = {
  day?: InputMaybe<Scalars['DateOnly']['input']>;
  hotelCode: Scalars['String']['input'];
  ingredientIndex: Scalars['Int']['input'];
  recipe: RecipeQL;
};

export enum CheapestItineraryStatusType {
  Failure = 'Failure',
  Success = 'Success',
  Unknown = 'Unknown',
}

export type CheapestPriceQL = {
  boardBasis?: Maybe<Scalars['String']['output']>;
  boardBasisOptions?: Maybe<Array<Maybe<BoardBasisOptionsResponseQL>>>;
  date: Scalars['DateTime']['output'];
  isRefundable: Scalars['Boolean']['output'];
  numberOfNights: Scalars['Int']['output'];
  placeCode?: Maybe<Scalars['String']['output']>;
  prices?: Maybe<PriceQL>;
  roomStays?: Maybe<Array<Maybe<RoomStayResponseQL>>>;
  totalPrice?: Maybe<MoneyQL>;
};

export type CheapestStayByHotelRequestQL = {
  constraint: ConstraintQL;
  day?: InputMaybe<Scalars['DateOnly']['input']>;
  ingredientIndex: Scalars['Int']['input'];
  recipe: RecipeQL;
};

export type ConstraintQL = {
  destination?: InputMaybe<Scalars['String']['input']>;
  destinationAirportIata?: InputMaybe<Scalars['String']['input']>;
  destinationCode?: InputMaybe<Scalars['Int']['input']>;
  hotelCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  polygon?: InputMaybe<Array<InputMaybe<CoordinateQL>>>;
  polygonId?: InputMaybe<Scalars['Int']['input']>;
  polygonIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  serializedConstraint?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['Int']['input']>;
};

export type CoordinateQL = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type DayTicketRateQL = {
  date?: Maybe<Scalars['DateTime']['output']>;
  rates?: Maybe<Array<Maybe<TicketRateQL>>>;
};

export type DecimalRangeTypeQL = {
  from?: InputMaybe<Scalars['Decimal']['input']>;
  to?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DestinationAdditionalTextQL = {
  activityTexts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fromIata?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  toIata?: Maybe<Scalars['String']['output']>;
};

export type DoubleRangeQL = {
  from?: Maybe<Scalars['Float']['output']>;
  to?: Maybe<Scalars['Float']['output']>;
};

export type DynamicDatePreferencesQL = {
  daysFromNow?: InputMaybe<Scalars['Int']['input']>;
  minimumDaysFromNow?: InputMaybe<Scalars['Int']['input']>;
  minimumDaysLeftInMonth?: InputMaybe<Scalars['Int']['input']>;
  mode: InputDynamicDatePreferencesModeTypeQL;
  monthsFromNow?: InputMaybe<Scalars['Int']['input']>;
  preferredMonths?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FerryIngredientResponseQL = IngredientResponseQL & {
  addToBasketToken?: Maybe<Scalars['String']['output']>;
  allCarriers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  carriers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  date?: Maybe<Scalars['Date']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  destinationTranslation?: Maybe<Scalars['String']['output']>;
  durationRangeInMinutes?: Maybe<DoubleRangeQL>;
  ferryNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  key?: Maybe<Scalars['String']['output']>;
  legDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  maxNumberOfStops?: Maybe<Scalars['Int']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  originTranslation?: Maybe<Scalars['String']['output']>;
  outBoundArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  outBoundDepartureTime?: Maybe<Scalars['DateTime']['output']>;
  price?: Maybe<MoneyQL>;
  totalPrice?: Maybe<MoneyQL>;
};

export type FlightIngredientResponseQL = IngredientResponseQL & {
  addToBasketToken?: Maybe<Scalars['String']['output']>;
  allCarriers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  carriers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  date?: Maybe<Scalars['DateTime']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  destinationTranslation?: Maybe<Scalars['String']['output']>;
  durationRangeInMinutes?: Maybe<DoubleRangeQL>;
  flightNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  key?: Maybe<Scalars['String']['output']>;
  legDescription?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  maxNumberOfStops?: Maybe<Scalars['Int']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  originTranslation?: Maybe<Scalars['String']['output']>;
  outBoundArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  outBoundDepartureTime?: Maybe<Scalars['DateTime']['output']>;
  price?: Maybe<MoneyQL>;
  priceRange?: Maybe<PriceRangeQL>;
  totalPrice?: Maybe<MoneyQL>;
};

export type GetCheapestItineraryResponseQL = {
  failureReason?: Maybe<Scalars['String']['output']>;
  itinerary?: Maybe<ItineraryResponseQL>;
  status: CheapestItineraryStatusType;
};

export type GetSuggestedAvailabilityRequestQL = {
  constraint: ConstraintQL;
  day: Scalars['DateOnly']['input'];
  ingredientIndex: Scalars['Int']['input'];
  numberOfSuggestions: Scalars['Int']['input'];
  recipe: RecipeQL;
  suggestedBy: InputAvailibityOrderQL;
};

export type GetSuggestedAvailabilityResponseQL = {
  results?: Maybe<Array<SuggestedAvailabilityResultQL>>;
};

export type HeartedHotelQL = {
  code?: InputMaybe<Scalars['String']['input']>;
  isRefundable?: InputMaybe<Scalars['Boolean']['input']>;
  roomCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rooms?: InputMaybe<Array<InputMaybe<HeartedRoomQL>>>;
};

export type HeartedRoomQL = {
  boardBasis?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  roomTypeId?: InputMaybe<Scalars['Int']['input']>;
};

export type HotelIngredientResponseQL = IngredientResponseQL & {
  addToBasketToken?: Maybe<Scalars['String']['output']>;
  alternativeSuggestion?: Maybe<HotelStayResponseQL>;
  date?: Maybe<Scalars['DateTime']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  lengthOfStay?: Maybe<LengthOfStayQL>;
  numberOfNights?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<MoneyQL>;
  priceRange?: Maybe<PriceRangeQL>;
  prices?: Maybe<PriceQL>;
  subIngredientResults?: Maybe<Array<Maybe<IngredientResponseQL>>>;
  suggested?: Maybe<HotelStayResponseQL>;
  suggestions?: Maybe<Array<HotelStayResponseQL>>;
  totalPrice?: Maybe<MoneyQL>;
};

export type HotelStayResponseQL = {
  addToBasketToken?: Maybe<Scalars['String']['output']>;
  boardBasisOptions?: Maybe<Array<Maybe<BoardBasisOptionsResponseQL>>>;
  date: Scalars['DateOnly']['output'];
  hotelCode?: Maybe<Scalars['String']['output']>;
  isRefundable: Scalars['Boolean']['output'];
  prices?: Maybe<PriceQL>;
  roomImages?: Maybe<Array<Maybe<RoomImageResponseQL>>>;
  roomStays?: Maybe<Array<Maybe<RoomStayResponseQL>>>;
  totalDiscountPrice?: Maybe<MoneyQL>;
  totalPrice?: Maybe<MoneyQL>;
};

export type ImageResponseQL = {
  imageName?: Maybe<Scalars['String']['output']>;
  imageService?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type IngredientQL = {
  arrivalTimeFilters?: InputMaybe<StringRangeTypeQL>;
  basePriceForDeltaPrice?: InputMaybe<Scalars['Decimal']['input']>;
  boardBasis?: InputMaybe<Array<InputMaybe<InputBoardBasisQL>>>;
  carriers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  departureTimeFilters?: InputMaybe<StringRangeTypeQL>;
  destination?: InputMaybe<Scalars['String']['input']>;
  destinationAirportIata?: InputMaybe<Scalars['String']['input']>;
  destinationCode?: InputMaybe<Scalars['Int']['input']>;
  flightNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  freeCancellation?: InputMaybe<Scalars['Boolean']['input']>;
  fromIata?: InputMaybe<Scalars['String']['input']>;
  getBoards?: InputMaybe<Scalars['Boolean']['input']>;
  hasAirConditioning?: InputMaybe<Scalars['Boolean']['input']>;
  hasElectricVehicleChargingStation?: InputMaybe<Scalars['Boolean']['input']>;
  hasGym?: InputMaybe<Scalars['Boolean']['input']>;
  hasInternet?: InputMaybe<Scalars['Boolean']['input']>;
  hasParking?: InputMaybe<Scalars['Boolean']['input']>;
  hasPool?: InputMaybe<Scalars['Boolean']['input']>;
  hasSpa?: InputMaybe<Scalars['Boolean']['input']>;
  heartedHotels?: InputMaybe<Array<InputMaybe<HeartedHotelQL>>>;
  hotelCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hotelName?: InputMaybe<Scalars['String']['input']>;
  includeAlternativeResults?: InputMaybe<Scalars['Boolean']['input']>;
  ingredientType?: InputMaybe<InputIngredientTypeQL>;
  isBusinessProperty?: InputMaybe<Scalars['Boolean']['input']>;
  isFamilyProperty?: InputMaybe<Scalars['Boolean']['input']>;
  isGreenSustainableProperty?: InputMaybe<Scalars['Boolean']['input']>;
  maxDurationInHours?: InputMaybe<Scalars['Float']['input']>;
  maxLayoverTimeInMinutes?: InputMaybe<Scalars['Int']['input']>;
  maxNumberOfHotels?: InputMaybe<Scalars['Int']['input']>;
  maxNumberOfStops?: InputMaybe<Scalars['Int']['input']>;
  numberOfNights?: InputMaybe<Scalars['Int']['input']>;
  numberOfSuggestions?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ownTransportType?: InputMaybe<OwnTransportTypeQL>;
  petsAreAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  polygon?: InputMaybe<Array<InputMaybe<CoordinateQL>>>;
  polygonId?: InputMaybe<Scalars['Int']['input']>;
  polygonIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priceFilters?: InputMaybe<DecimalRangeTypeQL>;
  selectedHotelTypes?: InputMaybe<Array<InputMaybe<InputSelectedHotelTypesQL>>>;
  selectedTicketDate?: InputMaybe<Scalars['DateOnly']['input']>;
  selectedTransportGroup?: InputMaybe<InputSelectedTransportGroupQL>;
  serializedConstraint?: InputMaybe<Scalars['String']['input']>;
  starRating?: InputMaybe<Scalars['Int']['input']>;
  stars?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  subIngredients?: InputMaybe<Array<InputMaybe<IngredientQL>>>;
  suggestedBy?: InputMaybe<InputAvailibityOrderQL>;
  tagId?: InputMaybe<Scalars['Int']['input']>;
  tickets?: InputMaybe<Array<InputMaybe<SelectedTicketQL>>>;
  toIata?: InputMaybe<Scalars['String']['input']>;
  transportTypes?: InputMaybe<Array<InputMaybe<InputTransportTypeQL>>>;
  vehicleType?: InputMaybe<InputTransportVehicleTypeQL>;
  vehicles?: InputMaybe<Array<InputMaybe<InputTransportVehicleTypeQL>>>;
};

export type IngredientResponseQL = {
  addToBasketToken?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export enum InputAvailibityOrderQL {
  /** Cheapest */
  Cheapest = 'CHEAPEST',
  /** None */
  None = 'NONE',
  /** Popular */
  Popular = 'POPULAR',
  /** RelativeWeight */
  RelativeWeight = 'RELATIVE_WEIGHT',
}

export enum InputBoardBasisQL {
  /** AllInclusive */
  AllInclusive = 'ALL_INCLUSIVE',
  /** Breakfast */
  Breakfast = 'BREAKFAST',
  /** FullBoard */
  FullBoard = 'FULL_BOARD',
  /** HalfBoard */
  HalfBoard = 'HALF_BOARD',
  /** Lunch */
  Lunch = 'LUNCH',
  /** RoomOnly */
  RoomOnly = 'ROOM_ONLY',
}

export enum InputDayOfWeekQL {
  /** Friday */
  Friday = 'FRIDAY',
  /** Monday */
  Monday = 'MONDAY',
  /** Saturday */
  Saturday = 'SATURDAY',
  /** Sunday */
  Sunday = 'SUNDAY',
  /** Thursday */
  Thursday = 'THURSDAY',
  /** Tuesday */
  Tuesday = 'TUESDAY',
  /** Wednesday */
  Wednesday = 'WEDNESDAY',
}

export enum InputDynamicDatePreferencesModeTypeQL {
  /** MonthsFromNow */
  MonthsFromNow = 'MONTHS_FROM_NOW',
  /** PreferredMonths */
  PreferredMonths = 'PREFERRED_MONTHS',
  /** Unknown */
  Unknown = 'UNKNOWN',
}

export enum InputIngredientTypeQL {
  /** Ferry */
  Ferry = 'FERRY',
  /** Flight */
  Flight = 'FLIGHT',
  /** Hotel */
  Hotel = 'HOTEL',
  /** None */
  None = 'NONE',
  /** OwnStay */
  OwnStay = 'OWN_STAY',
  /** OwnTransport */
  OwnTransport = 'OWN_TRANSPORT',
  /** Ticket */
  Ticket = 'TICKET',
  /** Transport */
  Transport = 'TRANSPORT',
}

export type InputPaxGroupQL = {
  childAges?: InputMaybe<Array<Scalars['Int']['input']>>;
  numberOfAdults: Scalars['Int']['input'];
};

export enum InputSaleChannelQL {
  /** Affiliate */
  Affiliate = 'AFFILIATE',
  /** B2B */
  B_2B = 'B_2_B',
  /** Direct */
  Direct = 'DIRECT',
  /** Groups */
  Groups = 'GROUPS',
  /** Mailing */
  Mailing = 'MAILING',
  /** MetaFlight */
  MetaFlight = 'META_FLIGHT',
  /** MetaHotel */
  MetaHotel = 'META_HOTEL',
  /** MetaPackage */
  MetaPackage = 'META_PACKAGE',
  /** None */
  None = 'NONE',
  /** PaidAdvertising */
  PaidAdvertising = 'PAID_ADVERTISING',
  /** PaidSearch */
  PaidSearch = 'PAID_SEARCH',
  /** Partner */
  Partner = 'PARTNER',
  /** Retail */
  Retail = 'RETAIL',
  /** ShareAndGain */
  ShareAndGain = 'SHARE_AND_GAIN',
  /** SoMe */
  SoMe = 'SO_ME',
  /** StenaLine */
  StenaLine = 'STENA_LINE',
  /** Test */
  Test = 'TEST',
  /** TravelAgency */
  TravelAgency = 'TRAVEL_AGENCY',
  /** WhiteLabel */
  WhiteLabel = 'WHITE_LABEL',
}

export enum InputSelectedHotelTypesQL {
  /** Apartment */
  Apartment = 'APARTMENT',
  /** Golf */
  Golf = 'GOLF',
  /** Hotel */
  Hotel = 'HOTEL',
  /** HouseOrCottage */
  HouseOrCottage = 'HOUSE_OR_COTTAGE',
  /** None */
  None = 'NONE',
  /** Ticket */
  Ticket = 'TICKET',
}

export type InputSelectedTransportGroupQL = {
  arrivalTime?: InputMaybe<Scalars['String']['input']>;
  departureTime?: InputMaybe<Scalars['String']['input']>;
  fromIata?: InputMaybe<Scalars['String']['input']>;
  landingExtraDays: Scalars['Int']['input'];
  mainCarrier?: InputMaybe<Scalars['String']['input']>;
  toIata?: InputMaybe<Scalars['String']['input']>;
};

export enum InputSourceTypeQL {
  /** Communications */
  Communications = 'COMMUNICATIONS',
  /** Feeds */
  Feeds = 'FEEDS',
  /** FileExport */
  FileExport = 'FILE_EXPORT',
  /** Lab */
  Lab = 'LAB',
  /** MarketPlace */
  MarketPlace = 'MARKET_PLACE',
  /** Microsites */
  Microsites = 'MICROSITES',
  /** PartnersPackageAPI */
  PartnersPackageApi = 'PARTNERS_PACKAGE_API',
  /** Planner */
  Planner = 'PLANNER',
  /** Sanity */
  Sanity = 'SANITY',
  /** Shop */
  Shop = 'SHOP',
  /** TripsAPI */
  TripsApi = 'TRIPS_API',
  /** Unknown */
  Unknown = 'UNKNOWN',
}

export enum InputTransportTypeQL {
  /** Ferry */
  Ferry = 'FERRY',
  /** Flight */
  Flight = 'FLIGHT',
  /** None */
  None = 'NONE',
}

export enum InputTransportVehicleTypeQL {
  /** Bicycle */
  Bicycle = 'BICYCLE',
  /** MiniBus4mHigh6mLong */
  MiniBus_4MHigh_6MLong = 'MINI_BUS_4_M_HIGH_6_M_LONG',
  /** MiniBus8mLong */
  MiniBus_8MLong = 'MINI_BUS_8_M_LONG',
  /** MotorBike */
  MotorBike = 'MOTOR_BIKE',
  /** MultiPurposeVehicle */
  MultiPurposeVehicle = 'MULTI_PURPOSE_VEHICLE',
  /** None */
  None = 'NONE',
  /** Vehicle4m70cmLong */
  Vehicle_4M_70CmLong = 'VEHICLE_4_M_70_CM_LONG',
  /** Vehicle6mLong */
  Vehicle_6MLong = 'VEHICLE_6_M_LONG',
}

export type IntRangeQL = {
  from?: Maybe<Scalars['Int']['output']>;
  to?: Maybe<Scalars['Int']['output']>;
};

export type ItineraryResponseQL = {
  isSearched?: Maybe<Scalars['Boolean']['output']>;
  isSuggested: Scalars['Boolean']['output'];
  itineraryKey?: Maybe<Scalars['String']['output']>;
  prices?: Maybe<PriceQL>;
  result?: Maybe<Array<Maybe<IngredientResponseQL>>>;
  searchedAt: Scalars['DateTime']['output'];
  totalPrice?: Maybe<MoneyQL>;
};

export type LegQL = {
  durationInMinutes: Scalars['Float']['output'];
  luggageInformation?: Maybe<Array<Maybe<LuggageInformationQL>>>;
  platingCarrier?: Maybe<Scalars['String']['output']>;
  segments?: Maybe<Array<Maybe<SegmentQL>>>;
};

export type LengthOfStayQL = {
  nightsHaveBeenSuggested: Scalars['Boolean']['output'];
  numberOfNights: Scalars['Int']['output'];
};

export type LuggageInformationQL = {
  included: Scalars['Boolean']['output'];
  pieces?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<LuggageTypeResult>;
  unit?: Maybe<LuggageUnitTypeResult>;
  weight?: Maybe<Scalars['Decimal']['output']>;
};

export enum LuggageTypeResult {
  CabinBag = 'CabinBag',
  CheckedBag = 'CheckedBag',
  None = 'None',
}

export enum LuggageUnitTypeResult {
  Kilograms = 'Kilograms',
  KilogramsAndPieces = 'KilogramsAndPieces',
  None = 'None',
  Pieces = 'Pieces',
}

export type MetadataRequestQL = {
  generatedFromAI?: InputMaybe<Scalars['Boolean']['input']>;
  originUrl?: InputMaybe<Scalars['String']['input']>;
  priceAccuracyToken?: InputMaybe<Scalars['String']['input']>;
  priceWeight?: InputMaybe<Scalars['Float']['input']>;
  salesChannel?: InputMaybe<InputSaleChannelQL>;
  sourceType?: InputMaybe<InputSourceTypeQL>;
};

export type MoneyQL = {
  amount?: Maybe<Scalars['Decimal']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
};

export type NoteResponseQL = {
  fromDate?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  toDate?: Maybe<Scalars['String']['output']>;
};

export type OwnStayResultQL = IngredientResponseQL & {
  addToBasketToken?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  numberOfNights?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<MoneyQL>;
  subIngredientResults?: Maybe<Array<Maybe<IngredientResponseQL>>>;
  totalPrice?: Maybe<MoneyQL>;
};

export type OwnTransportQL = IngredientResponseQL & {
  addToBasketToken?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  ownTransportType?: Maybe<OwnTransportTypeQL>;
  price?: Maybe<MoneyQL>;
  subIngredientResults?: Maybe<Array<Maybe<IngredientResponseQL>>>;
  totalPrice?: Maybe<MoneyQL>;
};

export enum OwnTransportTypeQL {
  /** Car */
  Car = 'CAR',
  /** Cycle */
  Cycle = 'CYCLE',
  /** Unknown */
  Unknown = 'UNKNOWN',
  /** Walk */
  Walk = 'WALK',
}

export type PaxResponseQL = {
  age?: Maybe<Scalars['Int']['output']>;
};

export type PriceQL = {
  deltaPrice?: Maybe<MoneyQL>;
  grossPrice?: Maybe<MoneyQL>;
  grossPricePerPerson?: Maybe<MoneyQL>;
  grossPriceWithAlternative?: Maybe<MoneyQL>;
  grossPriceWithAlternativePerPerson?: Maybe<MoneyQL>;
  price?: Maybe<MoneyQL>;
  priceIsWithTaxesIncluded?: Maybe<Scalars['Boolean']['output']>;
  pricePerPerson?: Maybe<MoneyQL>;
  pricePerPersonWithAlternative?: Maybe<MoneyQL>;
  totalPrice?: Maybe<MoneyQL>;
  totalPriceWithAlternative?: Maybe<MoneyQL>;
};

export type PriceRangeQL = {
  from?: Maybe<MoneyQL>;
  to?: Maybe<MoneyQL>;
};

export type Query = {
  bookingTokens?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cheapestItinerary?: Maybe<ItineraryResponseQL>;
  cheapestItineraryWithStatus?: Maybe<GetCheapestItineraryResponseQL>;
  getSuggestedAvailability?: Maybe<GetSuggestedAvailabilityResponseQL>;
  getThreadAI?: Maybe<AIThreadResponseQL>;
  getTicketRates?: Maybe<TicketRatesResponseQL>;
  getTransportList?: Maybe<TransportListResponseQL>;
  ratesByDay?: Maybe<Array<Maybe<DayTicketRateQL>>>;
  routesByRecipe?: Maybe<RouteResponseQL>;
  transportMatrix?: Maybe<TransportMatrixResponseQL>;
  validateRecipe?: Maybe<Scalars['Boolean']['output']>;
};

export type QuerybookingTokensArgs = {
  request: BookingTokenRequestQL;
};

export type QuerycheapestItineraryArgs = {
  recipe: RecipeQL;
};

export type QuerycheapestItineraryWithStatusArgs = {
  recipe: RecipeQL;
};

export type QuerygetSuggestedAvailabilityArgs = {
  request: GetSuggestedAvailabilityRequestQL;
};

export type QuerygetThreadAIArgs = {
  request: ThreadAIRequestQL;
};

export type QuerygetTicketRatesArgs = {
  request: TicketRequestQL;
  skipCache?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerygetTransportListArgs = {
  request: TransportListRequestQL;
};

export type QueryratesByDayArgs = {
  request: TicketRequestQL;
  skipCache?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryroutesByRecipeArgs = {
  numberOfRoutesToReturn?: InputMaybe<Scalars['Int']['input']>;
  recipe: RecipeQL;
};

export type QuerytransportMatrixArgs = {
  recipe: RecipeQL;
};

export type QueryvalidateRecipeArgs = {
  recipe: RecipeQL;
};

export type RebookableOptionQL = {
  addToBasketToken?: Maybe<Scalars['String']['output']>;
  rebookablePrice?: Maybe<MoneyQL>;
  rebookableTotalPrice?: Maybe<MoneyQL>;
};

export type RecipeQL = {
  affiliateId?: InputMaybe<Scalars['String']['input']>;
  avoidDateShift?: InputMaybe<Scalars['Boolean']['input']>;
  bypassRoundtripLogic?: InputMaybe<Scalars['Boolean']['input']>;
  days?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  daysOfTheWeek?: InputMaybe<Array<InputMaybe<InputDayOfWeekQL>>>;
  dontGroupByFlightNumbers?: InputMaybe<Scalars['Boolean']['input']>;
  dynamicDatePreferences?: InputMaybe<DynamicDatePreferencesQL>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDateOnly?: InputMaybe<Scalars['DateOnly']['input']>;
  featureToggles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ingredients?: InputMaybe<Array<InputMaybe<IngredientQL>>>;
  market: Scalars['Uri']['input'];
  metadata?: InputMaybe<MetadataRequestQL>;
  months?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  pax?: InputMaybe<Array<InputMaybe<InputPaxGroupQL>>>;
  returnEmptyIngredientResults?: InputMaybe<Scalars['Boolean']['input']>;
  searchForPackageRates?: InputMaybe<Scalars['Boolean']['input']>;
  searchOnlyLiveSelectedDay?: InputMaybe<Scalars['Boolean']['input']>;
  selectedDate?: InputMaybe<Scalars['DateOnly']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  skipCache?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDateOnly?: InputMaybe<Scalars['DateOnly']['input']>;
  suggestedBy?: InputMaybe<InputAvailibityOrderQL>;
  useNewScore?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RoomImageResponseQL = {
  links?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  roomTypeId: Scalars['Int']['output'];
};

export type RoomStayResponseQL = {
  basicDescription?: Maybe<Scalars['String']['output']>;
  boardBasis?: Maybe<Scalars['String']['output']>;
  cancellationPolicies?: Maybe<Array<Maybe<CancellationPolicyResponseQL>>>;
  description?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<ImageResponseQL>>>;
  notes?: Maybe<Array<Maybe<NoteResponseQL>>>;
  pax?: Maybe<Array<Maybe<PaxResponseQL>>>;
  price?: Maybe<MoneyQL>;
  prices?: Maybe<PriceQL>;
  roomCode?: Maybe<Scalars['String']['output']>;
  roomTypeId?: Maybe<Scalars['Int']['output']>;
  taxesAndFees?: Maybe<Array<Maybe<TaxAndFeeResponseQL>>>;
};

export type RouteQL = {
  flights?: Maybe<Array<Maybe<TransportResultQL>>>;
  priceAmount: Scalars['Decimal']['output'];
};

export type RouteResponseQL = {
  routes?: Maybe<Array<Maybe<RouteQL>>>;
};

export type SegmentQL = {
  arrivalDateTime: Scalars['DateTime']['output'];
  arrivalIata?: Maybe<Scalars['String']['output']>;
  carrier?: Maybe<Scalars['String']['output']>;
  departureDateTime: Scalars['DateTime']['output'];
  departureIata?: Maybe<Scalars['String']['output']>;
  durationInMinutes: Scalars['Float']['output'];
  flightNumber?: Maybe<Scalars['String']['output']>;
  isCabinMandatory: Scalars['Boolean']['output'];
  layoverTimeUntilNextSegmentInMinutes?: Maybe<Scalars['Float']['output']>;
  /** @deprecated luggageInformation was moved from SegmentQL to LegQL */
  luggageInformation?: Maybe<Array<Maybe<LuggageInformationQL>>>;
  operatingCarrier?: Maybe<Scalars['String']['output']>;
  transportType?: Maybe<TransportType>;
  transportationName?: Maybe<Scalars['String']['output']>;
  vehicleType?: Maybe<TransportVehicleType>;
  vehicles?: Maybe<Array<Maybe<TransportVehicleType>>>;
};

export type SelectedTicketQL = {
  ageRangeId?: InputMaybe<Scalars['String']['input']>;
  getQuantityFromPax?: InputMaybe<Scalars['Boolean']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  rateId?: InputMaybe<Scalars['String']['input']>;
  supplierToken?: InputMaybe<Scalars['String']['input']>;
  timeSlotId?: InputMaybe<Scalars['String']['input']>;
};

export type StringRangeTypeQL = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionsAsInRealtimeNotifications = {
  getCheapestStayByHotel?: Maybe<CheapestPriceQL>;
  searchCheapestStay?: Maybe<HotelStayResponseQL>;
  searchRecipeByItinerary?: Maybe<ItineraryResponseQL>;
};

export type SubscriptionsAsInRealtimeNotificationsgetCheapestStayByHotelArgs = {
  request: CheapestStayByHotelRequestQL;
};

export type SubscriptionsAsInRealtimeNotificationssearchCheapestStayArgs = {
  request: CheapestHotelStayRequestQL;
};

export type SubscriptionsAsInRealtimeNotificationssearchRecipeByItineraryArgs =
  {
    recipe: RecipeQL;
  };

export type SuggestedAvailabilityResultQL = {
  code?: Maybe<Scalars['String']['output']>;
  prices?: Maybe<PriceQL>;
  score: Scalars['Int']['output'];
  totalPrice: MoneyQL;
};

export type TaxAndFeeResponseQL = {
  amount?: Maybe<MoneyQL>;
  isIncludedInPrice: Scalars['Boolean']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type ThreadAIRequestQL = {
  market?: InputMaybe<Scalars['Uri']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type TicketIngredientResponseQL = IngredientResponseQL & {
  addToBasketToken?: Maybe<Scalars['String']['output']>;
  alternativeSuggestion?: Maybe<ActivityResultQL>;
  code?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  price?: Maybe<MoneyQL>;
  prices?: Maybe<PriceQL>;
  suggested?: Maybe<ActivityResultQL>;
  totalPrice?: Maybe<MoneyQL>;
};

export type TicketRateQL = {
  ageRanges?: Maybe<Array<Maybe<AgeRangeQL>>>;
  dateMainEvent?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  estimatedDate?: Maybe<Scalars['DateOnly']['output']>;
  isConfirmed: Scalars['Boolean']['output'];
  maximumAmountTickets?: Maybe<Scalars['Int']['output']>;
  minimumAmountTickets?: Maybe<Scalars['Int']['output']>;
  rateId?: Maybe<Scalars['String']['output']>;
  requiredAgeRanges?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ticketEndDate?: Maybe<Scalars['DateOnly']['output']>;
  ticketStartDate?: Maybe<Scalars['DateOnly']['output']>;
  timeSlots?: Maybe<Array<Maybe<TimeSlotsQL>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TicketRatesResponseQL = {
  hasFixedDates?: Maybe<Scalars['Boolean']['output']>;
  ratesByDay?: Maybe<Array<Maybe<DayTicketRateQL>>>;
};

export type TicketRequestQL = {
  affiliateId?: InputMaybe<Scalars['String']['input']>;
  basePriceForDeltaPrice?: InputMaybe<Scalars['Decimal']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  fromDateOnly?: InputMaybe<Scalars['DateOnly']['input']>;
  ingredientIndex?: InputMaybe<Scalars['Int']['input']>;
  market?: InputMaybe<Scalars['Uri']['input']>;
  pax?: InputMaybe<Array<InputPaxGroupQL>>;
  recipe?: InputMaybe<RecipeQL>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  toDateOnly?: InputMaybe<Scalars['DateOnly']['input']>;
};

export type TimeSlotsQL = {
  id?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
};

export type TransportGroupValueQL = {
  carriers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  combinableWith?: Maybe<Array<Scalars['Int']['output']>>;
  departureTime?: Maybe<Scalars['String']['output']>;
  durationInMinutes?: Maybe<DoubleRangeQL>;
  hasRestriction: Scalars['Boolean']['output'];
  iataCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['Int']['output'];
  isHomeboundRoundtrip: Scalars['Boolean']['output'];
  isOutboundRoundtrip: Scalars['Boolean']['output'];
  isSelectable?: Maybe<Scalars['Boolean']['output']>;
  isSelected: Scalars['Boolean']['output'];
  landingExtraDays: Scalars['Int']['output'];
  landingTime?: Maybe<Scalars['String']['output']>;
  price?: Maybe<PriceRangeQL>;
  restrictionWithGroupInIngredient: Scalars['Int']['output'];
  roundtripTiedToIngredient?: Maybe<Scalars['Int']['output']>;
  stops?: Maybe<IntRangeQL>;
  transportsInGroup: Scalars['Int']['output'];
};

export type TransportIngredientResponseQL = IngredientResponseQL & {
  addToBasketToken?: Maybe<Scalars['String']['output']>;
  allCarriers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  alternativeSuggestion?: Maybe<TransportResultQL>;
  date?: Maybe<Scalars['DateTime']['output']>;
  durationRangeInMinutes?: Maybe<DoubleRangeQL>;
  key?: Maybe<Scalars['String']['output']>;
  legIndex?: Maybe<Scalars['Int']['output']>;
  legs?: Maybe<Array<Maybe<LegQL>>>;
  price?: Maybe<MoneyQL>;
  priceRange?: Maybe<PriceRangeQL>;
  prices?: Maybe<PriceQL>;
  roundTripIndex?: Maybe<Scalars['Int']['output']>;
  suggested?: Maybe<TransportResultQL>;
  suggestions?: Maybe<Array<TransportResultQL>>;
  totalPrice?: Maybe<MoneyQL>;
};

export type TransportListRequestQL = {
  dayOnly?: InputMaybe<Scalars['DateOnly']['input']>;
  elementsInPage: Scalars['Int']['input'];
  ingredientIndex: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  recipe?: InputMaybe<RecipeQL>;
};

export type TransportListResponseQL = {
  roundTripIndex?: Maybe<Scalars['Int']['output']>;
  totalTransports: Scalars['Int']['output'];
  transports?: Maybe<Array<Maybe<TransportResultQL>>>;
};

export type TransportMatrixResponseQL = {
  response?: Maybe<Array<Maybe<Array<Maybe<TransportGroupValueQL>>>>>;
};

export type TransportResultQL = {
  addToBasketToken?: Maybe<Scalars['String']['output']>;
  isPromoted: Scalars['Boolean']['output'];
  legIndex: Scalars['Int']['output'];
  legs?: Maybe<Array<Maybe<LegQL>>>;
  price?: Maybe<MoneyQL>;
  prices?: Maybe<PriceQL>;
  rebookableOption?: Maybe<RebookableOptionQL>;
};

export enum TransportType {
  Ferry = 'Ferry',
  Flight = 'Flight',
  None = 'None',
}

export enum TransportVehicleType {
  Bicycle = 'Bicycle',
  MiniBus4mHigh6mLong = 'MiniBus4mHigh6mLong',
  MiniBus8mLong = 'MiniBus8mLong',
  MotorBike = 'MotorBike',
  MultiPurposeVehicle = 'MultiPurposeVehicle',
  None = 'None',
  Vehicle4m70cmLong = 'Vehicle4m70cmLong',
  Vehicle6mLong = 'Vehicle6mLong',
}

export type NoteFragment = {
  severity?: number | null;
  text?: string | null;
  fromDate?: string | null;
  toDate?: string | null;
} & { ' $fragmentName'?: 'NoteFragment' };

export type MoneyFragment = {
  amount?: number | null;
  currency?: string | null;
  currencySymbol?: string | null;
} & { ' $fragmentName'?: 'MoneyFragment' };

export type LegFragment = {
  durationInMinutes: number;
  platingCarrier?: string | null;
  luggageInformation?: Array<{
    included: boolean;
    pieces?: number | null;
    type?: LuggageTypeResult | null;
    unit?: LuggageUnitTypeResult | null;
    weight?: number | null;
  } | null> | null;
  segments?: Array<{
    carrier?: string | null;
    operatingCarrier?: string | null;
    departureIata?: string | null;
    departureDateTime: string;
    arrivalIata?: string | null;
    arrivalDateTime: string;
    layoverTimeUntilNextSegmentInMinutes?: number | null;
    transportType?: TransportType | null;
    vehicles?: Array<TransportVehicleType | null> | null;
    transportationName?: string | null;
    isCabinMandatory: boolean;
    durationInMinutes: number;
    transportId?: string | null;
  } | null> | null;
} & { ' $fragmentName'?: 'LegFragment' };

export type ActivitySubIngredientFragment = {
  date?: string | null;
  type: 'TicketIngredientResponseQL';
  suggested?: {
    code: string;
    prices?: {
      totalPrice?: {
        ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
      } | null;
    } | null;
    activityTicketResults?: Array<{
      rateId?: string | null;
      title?: string | null;
      ageRangeId?: string | null;
      description?: string | null;
      timeSlotId?: string | null;
      timeSlotStartTime?: string | null;
      supplierToken?: string | null;
      dateMainEvent?: string | null;
      ticketStartDate?: DateOnlyString | null;
      ticketEndDate?: DateOnlyString | null;
      isConfirmed: boolean;
      quantity: number;
    } | null> | null;
  } | null;
  alternativeSuggestion?: {
    code: string;
    prices?: {
      totalPriceWithAlternative?: {
        ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
      } | null;
    } | null;
    activityTicketResults?: Array<{
      rateId?: string | null;
      title?: string | null;
      ageRangeId?: string | null;
      description?: string | null;
      timeSlotId?: string | null;
      timeSlotStartTime?: string | null;
      supplierToken?: string | null;
      dateMainEvent?: string | null;
      ticketStartDate?: DateOnlyString | null;
      ticketEndDate?: DateOnlyString | null;
      isConfirmed: boolean;
      quantity: number;
    } | null> | null;
  } | null;
} & { ' $fragmentName'?: 'ActivitySubIngredientFragment' };

export type searchItinerariesSubscriptionVariables = Exact<{
  recipe: RecipeQL;
}>;

export type searchItinerariesSubscription = {
  searchRecipeByItinerary?: {
    itineraryKey?: string | null;
    isSuggested: boolean;
    totalPrice?: { ' $fragmentRefs'?: { MoneyFragment: MoneyFragment } } | null;
    prices?: {
      priceIsWithTaxesIncluded?: boolean | null;
      totalPrice?: {
        ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
      } | null;
      totalPriceWithAlternative?: {
        ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
      } | null;
      grossPrice?: {
        ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
      } | null;
      grossPriceWithAlternative?: {
        ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
      } | null;
      pricePerPerson?: {
        ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
      } | null;
      grossPricePerPerson?: {
        ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
      } | null;
      pricePerPersonWithAlternative?: {
        ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
      } | null;
      grossPriceWithAlternativePerPerson?: {
        ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
      } | null;
    } | null;
    result?: Array<
      | { type: 'FerryIngredientResponseQL' }
      | { type: 'FlightIngredientResponseQL' }
      | {
          date?: string | null;
          type: 'HotelIngredientResponseQL';
          lengthOfStay?: {
            numberOfNights: number;
            nightsHaveBeenSuggested: boolean;
          } | null;
          priceRange?: {
            from?: {
              ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
            } | null;
            to?: { ' $fragmentRefs'?: { MoneyFragment: MoneyFragment } } | null;
          } | null;
          suggested?: {
            addToBasketToken?: string | null;
            isRefundable: boolean;
            code?: string | null;
            prices?: {
              priceIsWithTaxesIncluded?: boolean | null;
              grossPrice?: {
                ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
              } | null;
            } | null;
            totalPrice?: {
              ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
            } | null;
            rooms?: Array<{
              description?: string | null;
              basicDescription?: string | null;
              boardBasis?: string | null;
              pax?: Array<{ age?: number | null } | null> | null;
              price?: {
                ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
              } | null;
              cancellationPolicies?: Array<{
                fromDate?: string | null;
                fromDateIso?: string | null;
                amount?: {
                  ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
                } | null;
              } | null> | null;
              taxesAndFees?: Array<{
                type?: string | null;
                isIncludedInPrice: boolean;
                amount?: {
                  ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
                } | null;
              } | null> | null;
            } | null> | null;
          } | null;
          suggestions?: Array<{
            addToBasketToken?: string | null;
            isRefundable: boolean;
            code?: string | null;
            prices?: {
              priceIsWithTaxesIncluded?: boolean | null;
              totalPrice?: {
                ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
              } | null;
              deltaPrice?: {
                ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
              } | null;
              grossPrice?: {
                ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
              } | null;
            } | null;
            rooms?: Array<{
              description?: string | null;
              basicDescription?: string | null;
              boardBasis?: string | null;
              pax?: Array<{ age?: number | null } | null> | null;
              price?: {
                ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
              } | null;
              cancellationPolicies?: Array<{
                fromDate?: string | null;
                fromDateIso?: string | null;
                amount?: {
                  ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
                } | null;
              } | null> | null;
              taxesAndFees?: Array<{
                type?: string | null;
                isIncludedInPrice: boolean;
                amount?: {
                  ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
                } | null;
              } | null> | null;
            } | null> | null;
          }> | null;
          alternativeSuggestion?: {
            addToBasketToken?: string | null;
            isRefundable: boolean;
            code?: string | null;
            totalPrice?: {
              ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
            } | null;
            rooms?: Array<{
              description?: string | null;
              basicDescription?: string | null;
              boardBasis?: string | null;
              roomCode?: string | null;
              pax?: Array<{ age?: number | null } | null> | null;
              price?: {
                ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
              } | null;
              cancellationPolicies?: Array<{
                fromDate?: string | null;
                fromDateIso?: string | null;
                amount?: {
                  ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
                } | null;
              } | null> | null;
              taxesAndFees?: Array<{
                type?: string | null;
                isIncludedInPrice: boolean;
                amount?: {
                  ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
                } | null;
              } | null> | null;
            } | null> | null;
          } | null;
          subIngredientResults?: Array<
            | { type: 'FerryIngredientResponseQL' }
            | { type: 'FlightIngredientResponseQL' }
            | { type: 'HotelIngredientResponseQL' }
            | { type: 'OwnStayResultQL' }
            | { type: 'OwnTransportQL' }
            | ({ type: 'TicketIngredientResponseQL' } & {
                ' $fragmentRefs'?: {
                  ActivitySubIngredientFragment: ActivitySubIngredientFragment;
                };
              })
            | { type: 'TransportIngredientResponseQL' }
            | null
          > | null;
        }
      | {
          date?: string | null;
          numberOfNights?: number | null;
          type: 'OwnStayResultQL';
          subIngredientResults?: Array<
            | { type: 'FerryIngredientResponseQL' }
            | { type: 'FlightIngredientResponseQL' }
            | { type: 'HotelIngredientResponseQL' }
            | { type: 'OwnStayResultQL' }
            | { type: 'OwnTransportQL' }
            | ({ type: 'TicketIngredientResponseQL' } & {
                ' $fragmentRefs'?: {
                  ActivitySubIngredientFragment: ActivitySubIngredientFragment;
                };
              })
            | { type: 'TransportIngredientResponseQL' }
            | null
          > | null;
        }
      | {
          date?: string | null;
          ownTransportType?: OwnTransportTypeQL | null;
          type: 'OwnTransportQL';
        }
      | { type: 'TicketIngredientResponseQL' }
      | {
          addToBasketToken?: string | null;
          date?: string | null;
          allCarriers?: Array<string | null> | null;
          legIndex?: number | null;
          type: 'TransportIngredientResponseQL';
          durationRangeInMinutes?: {
            from?: number | null;
            to?: number | null;
          } | null;
          totalPrice?: {
            ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
          } | null;
          priceRange?: {
            from?: { amount?: number | null } | null;
            to?: { amount?: number | null } | null;
          } | null;
          legs?: Array<{
            ' $fragmentRefs'?: { LegFragment: LegFragment };
          } | null> | null;
          alternativeSuggestion?: {
            addToBasketToken?: string | null;
            legIndex: number;
            totalPrice?: {
              ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
            } | null;
            legs?: Array<{
              ' $fragmentRefs'?: { LegFragment: LegFragment };
            } | null> | null;
          } | null;
          suggested?: {
            rebookableOption?: {
              addToBasketToken?: string | null;
              rebookablePrice?: {
                ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
              } | null;
              rebookableTotalPrice?: {
                ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
              } | null;
            } | null;
          } | null;
        }
      | null
    > | null;
  } | null;
};

export type searchItinerarySuggestionPricesSubscriptionVariables = Exact<{
  recipe: RecipeQL;
}>;

export type searchItinerarySuggestionPricesSubscription = {
  searchRecipeByItinerary?: {
    itineraryKey?: string | null;
    isSuggested: boolean;
    prices?: {
      totalPrice?: {
        ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
      } | null;
      totalPriceWithAlternative?: {
        ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
      } | null;
    } | null;
    result?: Array<
      | { type: 'FerryIngredientResponseQL' }
      | { type: 'FlightIngredientResponseQL' }
      | { date?: string | null; type: 'HotelIngredientResponseQL' }
      | { date?: string | null; type: 'OwnStayResultQL' }
      | { date?: string | null; type: 'OwnTransportQL' }
      | { type: 'TicketIngredientResponseQL' }
      | { date?: string | null; type: 'TransportIngredientResponseQL' }
      | null
    > | null;
  } | null;
};

export type searchDestinationAvailabilitySubscriptionVariables = Exact<{
  request: CheapestStayByHotelRequestQL;
}>;

export type searchDestinationAvailabilitySubscription = {
  getCheapestStayByHotel?: {
    placeCode?: string | null;
    date: string;
    prices?: {
      priceIsWithTaxesIncluded?: boolean | null;
      totalPrice?: {
        ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
      } | null;
      grossPrice?: {
        ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
      } | null;
    } | null;
    rooms?: Array<{ boardBasis?: string | null } | null> | null;
  } | null;
};

export type searchProductAvailabilitySubscriptionVariables = Exact<{
  request: CheapestHotelStayRequestQL;
}>;

export type searchProductAvailabilitySubscription = {
  searchCheapestStay?: {
    date: DateOnlyString;
    isRefundable: boolean;
    addToBasketToken?: string | null;
    code?: string | null;
    totalPrice?: { ' $fragmentRefs'?: { MoneyFragment: MoneyFragment } } | null;
    prices?: {
      priceIsWithTaxesIncluded?: boolean | null;
      totalPrice?: {
        ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
      } | null;
      grossPrice?: {
        ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
      } | null;
    } | null;
    rooms?: Array<{
      description?: string | null;
      basicDescription?: string | null;
      boardBasis?: string | null;
      roomCode?: string | null;
      roomTypeId?: number | null;
      notes?: Array<{
        ' $fragmentRefs'?: { NoteFragment: NoteFragment };
      } | null> | null;
      price?: { ' $fragmentRefs'?: { MoneyFragment: MoneyFragment } } | null;
      cancellationPolicies?: Array<{
        fromDate?: string | null;
        fromDateIso?: string | null;
        amount?: { ' $fragmentRefs'?: { MoneyFragment: MoneyFragment } } | null;
      } | null> | null;
      taxesAndFees?: Array<{
        type?: string | null;
        isIncludedInPrice: boolean;
        amount?: { ' $fragmentRefs'?: { MoneyFragment: MoneyFragment } } | null;
      } | null> | null;
      images?: Array<{ imageUrl?: string | null } | null> | null;
      pax?: Array<{ age?: number | null } | null> | null;
    } | null> | null;
  } | null;
};

export type searchTicketAvailabilityQueryVariables = Exact<{
  request: TicketRequestQL;
}>;

export type searchTicketAvailabilityQuery = {
  getTicketRates?: {
    hasFixedDates?: boolean | null;
    ratesByDay?: Array<{
      date?: string | null;
      rates?: Array<{
        rateId?: string | null;
        title?: string | null;
        description?: string | null;
        requiredAgeRanges?: Array<string | null> | null;
        minimumAmountTickets?: number | null;
        maximumAmountTickets?: number | null;
        dateMainEvent?: string | null;
        ticketStartDate?: DateOnlyString | null;
        ticketEndDate?: DateOnlyString | null;
        estimatedDate?: DateOnlyString | null;
        isConfirmed: boolean;
        ageRanges?: Array<{
          minAge: number;
          maxAge?: number | null;
          minimumTicketsPerAgeRange?: number | null;
          description?: string | null;
          quantityAvailable?: number | null;
          supplierToken?: string | null;
          ageRangeId?: string | null;
          price?: {
            ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
          } | null;
          availableTimeslotsPrices?: Array<{
            availabletimeSlotId?: string | null;
            amount: number;
            currency?: string | null;
            currencySymbol?: string | null;
            quantityAvailable?: number | null;
          } | null> | null;
        } | null> | null;
        timeSlots?: Array<{
          startTime?: string | null;
          timeSlotId?: string | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type getTicketBookingTokensQueryVariables = Exact<{
  request: BookingTokenRequestQL;
}>;

export type getTicketBookingTokensQuery = {
  bookingTokens?: Array<string | null> | null;
};

export type getTransportAvailabilityQueryVariables = Exact<{
  request: TransportListRequestQL;
}>;

export type getTransportAvailabilityQuery = {
  getTransportList?: {
    totalTransports: number;
    transports?: Array<{
      addToBasketToken?: string | null;
      legIndex: number;
      isPromoted: boolean;
      totalPrice?: {
        ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
      } | null;
      legs?: Array<{
        ' $fragmentRefs'?: { LegFragment: LegFragment };
      } | null> | null;
      rebookableOption?: {
        addToBasketToken?: string | null;
        rebookablePrice?: {
          ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
        } | null;
        rebookableTotalPrice?: {
          ' $fragmentRefs'?: { MoneyFragment: MoneyFragment };
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetSuggestedQueryVariables = Exact<{
  request: GetSuggestedAvailabilityRequestQL;
}>;

export type GetSuggestedQuery = {
  getSuggestedAvailability?: {
    results?: Array<{
      code?: string | null;
      totalPrice: { ' $fragmentRefs'?: { MoneyFragment: MoneyFragment } };
    }> | null;
  } | null;
};

export const NoteFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Note' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NoteResponseQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fromDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toDate' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NoteFragment, unknown>;
export const LegFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Leg' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LegQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'durationInMinutes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'luggageInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'included' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pieces' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'platingCarrier' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'segments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'carrier' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operatingCarrier' },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'transportId' },
                  name: { kind: 'Name', value: 'flightNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departureIata' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departureDateTime' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'arrivalIata' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrivalDateTime' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'layoverTimeUntilNextSegmentInMinutes',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transportType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'vehicles' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transportationName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCabinMandatory' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'durationInMinutes' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LegFragment, unknown>;
export const MoneyFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Money' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MoneyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencySymbol' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MoneyFragment, unknown>;
export const ActivitySubIngredientFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActivitySubIngredient' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TicketIngredientResponseQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'suggested' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPrice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Money' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityTicketResults' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'quantity' },
                        name: { kind: 'Name', value: 'quantityOfTickets' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rateId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ageRangeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeSlotId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeSlotStartTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'supplierToken' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateMainEvent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticketStartDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticketEndDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isConfirmed' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alternativeSuggestion' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'totalPriceWithAlternative',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Money' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityTicketResults' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'quantity' },
                        name: { kind: 'Name', value: 'quantityOfTickets' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rateId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ageRangeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeSlotId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeSlotStartTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'supplierToken' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateMainEvent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticketStartDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticketEndDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isConfirmed' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'type' },
            name: { kind: 'Name', value: '__typename' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Money' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MoneyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencySymbol' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActivitySubIngredientFragment, unknown>;
export const searchItinerariesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'searchItineraries' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'recipe' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RecipeQL' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchRecipeByItinerary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'recipe' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'recipe' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'itineraryKey' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuggested' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Money' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPrice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Money' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'totalPriceWithAlternative',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Money' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'grossPrice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Money' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'grossPriceWithAlternative',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Money' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pricePerPerson' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Money' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'grossPricePerPerson' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Money' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'pricePerPersonWithAlternative',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Money' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'grossPriceWithAlternativePerPerson',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Money' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'priceIsWithTaxesIncluded',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'OwnStayResultQL' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'date' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'numberOfNights' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'subIngredientResults',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {
                                        kind: 'Name',
                                        value: 'TicketIngredientResponseQL',
                                      },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'ActivitySubIngredient',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'type' },
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'OwnTransportQL' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'date' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ownTransportType' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'HotelIngredientResponseQL',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lengthOfStay' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'numberOfNights',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'nightsHaveBeenSuggested',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'date' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'priceRange' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'from' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'Money',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'to' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'Money',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'suggested' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'prices' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'grossPrice',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'Money',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'priceIsWithTaxesIncluded',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'addToBasketToken',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'code' },
                                    name: { kind: 'Name', value: 'hotelCode' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'totalPrice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'Money',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'isRefundable',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'rooms' },
                                    name: { kind: 'Name', value: 'roomStays' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'description',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'basicDescription',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'boardBasis',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'pax' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'age',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'price',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'Money',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'cancellationPolicies',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'amount',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'Money',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'fromDate',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'fromDateIso',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'taxesAndFees',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'amount',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'Money',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'type',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'isIncludedInPrice',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'suggestions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'addToBasketToken',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'code' },
                                    name: { kind: 'Name', value: 'hotelCode' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'prices' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'totalPrice',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'Money',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'deltaPrice',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'Money',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'grossPrice',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'Money',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'priceIsWithTaxesIncluded',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'isRefundable',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'rooms' },
                                    name: { kind: 'Name', value: 'roomStays' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'description',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'basicDescription',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'boardBasis',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'pax' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'age',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'price',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'Money',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'cancellationPolicies',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'amount',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'Money',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'fromDate',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'fromDateIso',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'taxesAndFees',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'amount',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'Money',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'type',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'isIncludedInPrice',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'alternativeSuggestion',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'addToBasketToken',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'code' },
                                    name: { kind: 'Name', value: 'hotelCode' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'totalPrice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'Money',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'isRefundable',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'rooms' },
                                    name: { kind: 'Name', value: 'roomStays' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'description',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'basicDescription',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'boardBasis',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'roomCode',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'pax' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'age',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'price',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'Money',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'cancellationPolicies',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'amount',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'Money',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'fromDate',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'fromDateIso',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'taxesAndFees',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'amount',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'Money',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'type',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'isIncludedInPrice',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'subIngredientResults',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {
                                        kind: 'Name',
                                        value: 'TicketIngredientResponseQL',
                                      },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'ActivitySubIngredient',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'type' },
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'TransportIngredientResponseQL',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'addToBasketToken' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'date' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'allCarriers' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'durationRangeInMinutes',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'from' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'to' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalPrice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'Money' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'priceRange' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'from' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'amount',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'to' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'amount',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'legs' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'Leg' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'legIndex' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'alternativeSuggestion',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'addToBasketToken',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    alias: {
                                      kind: 'Name',
                                      value: 'totalPrice',
                                    },
                                    name: { kind: 'Name', value: 'price' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'Money',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'legs' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: { kind: 'Name', value: 'Leg' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'legIndex' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'suggested' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'rebookableOption',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'addToBasketToken',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'rebookablePrice',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'Money',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'rebookableTotalPrice',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'Money',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'type' },
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Money' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MoneyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencySymbol' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActivitySubIngredient' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TicketIngredientResponseQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'suggested' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPrice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Money' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityTicketResults' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'quantity' },
                        name: { kind: 'Name', value: 'quantityOfTickets' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rateId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ageRangeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeSlotId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeSlotStartTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'supplierToken' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateMainEvent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticketStartDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticketEndDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isConfirmed' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alternativeSuggestion' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'totalPriceWithAlternative',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Money' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityTicketResults' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'quantity' },
                        name: { kind: 'Name', value: 'quantityOfTickets' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rateId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ageRangeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeSlotId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeSlotStartTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'supplierToken' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateMainEvent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticketStartDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticketEndDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isConfirmed' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'type' },
            name: { kind: 'Name', value: '__typename' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Leg' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LegQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'durationInMinutes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'luggageInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'included' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pieces' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'platingCarrier' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'segments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'carrier' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operatingCarrier' },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'transportId' },
                  name: { kind: 'Name', value: 'flightNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departureIata' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departureDateTime' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'arrivalIata' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrivalDateTime' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'layoverTimeUntilNextSegmentInMinutes',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transportType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'vehicles' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transportationName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCabinMandatory' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'durationInMinutes' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  searchItinerariesSubscription,
  searchItinerariesSubscriptionVariables
>;
export const searchItinerarySuggestionPricesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'searchItinerarySuggestionPrices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'recipe' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RecipeQL' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchRecipeByItinerary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'recipe' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'recipe' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'itineraryKey' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuggested' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPrice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Money' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'totalPriceWithAlternative',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Money' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'OwnStayResultQL' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'date' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'OwnTransportQL' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'date' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'HotelIngredientResponseQL',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'date' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'TransportIngredientResponseQL',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'date' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'type' },
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Money' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MoneyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencySymbol' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  searchItinerarySuggestionPricesSubscription,
  searchItinerarySuggestionPricesSubscriptionVariables
>;
export const searchDestinationAvailabilityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'searchDestinationAvailability' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'request' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheapestStayByHotelRequestQL' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCheapestStayByHotel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'request' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'placeCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPrice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Money' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'grossPrice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Money' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'priceIsWithTaxesIncluded',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'rooms' },
                  name: { kind: 'Name', value: 'roomStays' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'boardBasis' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Money' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MoneyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencySymbol' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  searchDestinationAvailabilitySubscription,
  searchDestinationAvailabilitySubscriptionVariables
>;
export const searchProductAvailabilityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'searchProductAvailability' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'request' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheapestHotelStayRequestQL' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchCheapestStay' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'request' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'code' },
                  name: { kind: 'Name', value: 'hotelCode' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Money' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPrice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Money' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'grossPrice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Money' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'priceIsWithTaxesIncluded',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isRefundable' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addToBasketToken' },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'rooms' },
                  name: { kind: 'Name', value: 'roomStays' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Note' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'basicDescription' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'boardBasis' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'roomCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'roomTypeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Money' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancellationPolicies' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'Money' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fromDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fromDateIso' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'taxesAndFees' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'Money' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'isIncludedInPrice',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'images' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'imageUrl' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pax' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'age' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Money' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MoneyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencySymbol' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Note' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NoteResponseQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fromDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'toDate' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  searchProductAvailabilitySubscription,
  searchProductAvailabilitySubscriptionVariables
>;
export const searchTicketAvailabilityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'searchTicketAvailability' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'request' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TicketRequestQL' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getTicketRates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'request' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hasFixedDates' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ratesByDay' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rates' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rateId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'title' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ageRanges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    alias: {
                                      kind: 'Name',
                                      value: 'ageRangeId',
                                    },
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'minAge' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'maxAge' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'minimumTicketsPerAgeRange',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'price' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'Money',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'description',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'availableTimeslotsPrices',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'availabletimeSlotId',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'amount',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'currency',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'currencySymbol',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'quantityAvailable',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'quantityAvailable',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'supplierToken',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'requiredAgeRanges',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'timeSlots' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    alias: {
                                      kind: 'Name',
                                      value: 'timeSlotId',
                                    },
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'startTime' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'minimumAmountTickets',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'maximumAmountTickets',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'dateMainEvent' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ticketStartDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ticketEndDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'estimatedDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isConfirmed' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Money' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MoneyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencySymbol' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  searchTicketAvailabilityQuery,
  searchTicketAvailabilityQueryVariables
>;
export const getTicketBookingTokensDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTicketBookingTokens' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'request' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BookingTokenRequestQL' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookingTokens' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'request' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  getTicketBookingTokensQuery,
  getTicketBookingTokensQueryVariables
>;
export const getTransportAvailabilityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTransportAvailability' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'request' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TransportListRequestQL' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getTransportList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'request' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalTransports' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transports' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addToBasketToken' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'totalPrice' },
                        name: { kind: 'Name', value: 'price' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Money' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'legs' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Leg' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'legIndex' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPromoted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rebookableOption' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'addToBasketToken' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rebookablePrice' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'Money' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'rebookableTotalPrice',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'Money' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Money' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MoneyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencySymbol' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Leg' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LegQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'durationInMinutes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'luggageInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'included' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pieces' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weight' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'platingCarrier' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'segments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'carrier' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operatingCarrier' },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'transportId' },
                  name: { kind: 'Name', value: 'flightNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departureIata' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departureDateTime' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'arrivalIata' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrivalDateTime' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'layoverTimeUntilNextSegmentInMinutes',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transportType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'vehicles' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transportationName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCabinMandatory' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'durationInMinutes' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  getTransportAvailabilityQuery,
  getTransportAvailabilityQueryVariables
>;
export const GetSuggestedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSuggested' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'request' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'GetSuggestedAvailabilityRequestQL',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSuggestedAvailability' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'request' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'results' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPrice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Money' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Money' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MoneyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencySymbol' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSuggestedQuery, GetSuggestedQueryVariables>;
